import { useState, useCallback } from 'react';
import type { SnackbarIntent } from '@coolblue-development/freddy';

interface SnackbarState {
  open: boolean;
  title: string;
  description?: string;
  intent: SnackbarIntent;
  duration?: number;
}

interface UseSnackbar {
  snackbar: SnackbarState;
  show: (title: string, intent?: SnackbarIntent, description?: string, duration?: number) => void;
  hideSnackbar: () => void;
  resetSnackbar: () => void;
}

export const useSnackbar = (): UseSnackbar => {
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    open: false,
    title: '',
    description: undefined,
    intent: 'base',
    duration: undefined
  });

  const show = useCallback(
    (title: string, intent: SnackbarIntent = 'base', description?: string, duration?: number): void => {
      setSnackbar({
        open: true,
        title,
        description,
        intent,
        duration
      });
    },
    []
  );

  const hideSnackbar = useCallback((): void => {
    setSnackbar(prev => ({ ...prev, open: false }));
  }, []);

  const resetSnackbar = useCallback((): void => {
    setSnackbar({
      open: false,
      title: '',
      description: undefined,
      intent: 'base',
      duration: undefined
    });
  }, []);

  return {
    snackbar,
    show,
    hideSnackbar,
    resetSnackbar
  };
};
